import API from "shared/services/Api";

export const notifications = async (id: string) =>
  API.get(`oc/notificacoes-dentista?id=${id}`);

export const readyNotification = async (id: string, idNotificacao: number) =>
  API.post(`oc/notificacoes-dentista/${idNotificacao}?id=${id}`, id);
